import App from './App.svelte';

/** FAB Component */
let search = window.FAB_PLUGIN.to_display.find( e => 'search' === e.type );
const app = new App({
	target: document.querySelector("#fab-search-dom"),
	props: { search }
});

export default app;